import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

import { useOpenState } from "../contexts/OpenContext";
import AdminContextProvider from "../contexts/AdminContext";
import * as API from "../api/request";

import Layout from "../components/Layout";
import Home from "../pages/Home";
import Detail from "../pages/Detail";

import AdminLayout from "../components/AdminLayout";
import Admin from "../pages/Admin";

const Router = () => {
  const { state, dispatch } = useOpenState();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("token")) {
      API.getUserInfo()
        .then((res) => {
          var group = res.usergroup.split(",").map((x) => +x);
          dispatch({ type: "LOGIN", data: res, userGroupList: group });
        })
        .catch(() => {
          navigate("/");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route
        exact
        path="/"
        element={
          <Layout>
            <Home />
          </Layout>
        }
      />
      <Route
        exact
        path={"/:id"}
        element={
          <Layout>
            <Detail />
          </Layout>
        }
      />
      <Route
        exact
        path="/admin"
        element={
          state.loggedIn ? (
            <AdminContextProvider>
              <AdminLayout>
                <Admin />
              </AdminLayout>
            </AdminContextProvider>
          ) : (
            <div></div>
          )
        }
      />
    </Routes>
  );
};

export default React.memo(Router);
